import Vue from 'vue'
// import VueCompositionAPI from "@vue/composition-api";
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Variables from "./plugins/variables";
import Functions from "./plugins/functions";
import Dayjs from "./plugins/dayjs";
import Snotify, { SnotifyPosition } from 'vue-snotify'
import i18n from './i18n'
import VueMeta from 'vue-meta'

const options = {
  toast: {
    position: SnotifyPosition.rightBottom
  }
}

Vue.use(Snotify, options)

// Vue.use(VueCompositionAPI);

Vue.use(Variables);
Vue.use(Functions);
Vue.use(VueMeta)
Vue.use(Dayjs)

Vue.prototype.$ApiUrl = process.env.VUE_APP_API_URL;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')